export const GET_MEMBERSHIPS = 'GET_MEMBERSHIPS';
export const PURCHASE_MEMBERSHIP = 'PURCHASE_MEMBERSHIP';
export const MEMBERSHIP_ERROR = 'MEMBERSHIP_ERROR';
